import * as thermalMath from '../../utils/thermal-math';

import { getItemByNid, getValue } from '../../utils/calculations-helper';

import { buildUIStringArray, getCalculation, getSection } from '../../utils/index';

import { CALCULATION_TYPE_VERTICAL_TANK, CALCULATION_TYPE_HORIZONTAL_TANK, CALCULATION_TYPE_RECTANGULAR_TANK, CALCULATION_CALCULATE_RESULTS, updateResults } from '../../modules/calculation';

function makeFaceCalculation(c, ui, s, claddingValue,
            noInsulation, insulationLayers, supports, emissivity, width, height,
            material, content, energySource, environment, cladding, products, settings,
            language, country, calcPipe = false, target, uninsWidth, uninsHeight) {
  let retO = {};
  let layers = [];
  let maxTemperatures = [];
  let layerProducts = [];
  let nominalDensity = [];
  let lambdas = [ [ getValue(material['Thermal-conductivity'], 'float') ]];

  let uninsulatedHeatLossResults, heatLossResults;

  let innerDiameters, outerDiameters, innerDiameter, outerDiameter, thicknesses;

  if(calcPipe) {
      // Diameter less that pipe-plane treshold value
    innerDiameters = [ getValue(s.outerDiameter, 'mmToMeters') - 2 * getValue(s.thickness, 'mmToMeters') ];
    outerDiameters = [ getValue(s.outerDiameter, 'mmToMeters') ];
    innerDiameter = getValue(s.outerDiameter, 'mmToMeters');
    outerDiameter = getValue(s.outerDiameter, 'mmToMeters');

    for(let j = 0; j < insulationLayers.length; j++) {
      layers.push(getItemByNid(insulationLayers[insulationLayers.length - j - 1].selectedItem, products));
      lambdas.push([getValue(layers[j].a, 'float'), getValue(layers[j].b, 'float'), getValue(layers[j].c, 'float'), getValue(layers[j].d, 'float')]);

      maxTemperatures.push({mst: getValue(layers[j].MST, 'int'), facing: getValue(layers[j]['Facing-MST'], 'int'), net: getValue(layers[j]['Net-MST'], 'int')});

      outerDiameter = innerDiameter + 2 * getValue(insulationLayers[insulationLayers.length - j - 1].selectedThickness, 'mmToMeters');
      innerDiameters.push(innerDiameter);
      outerDiameters.push(outerDiameter);
      innerDiameter = outerDiameter;

      nominalDensity.push(getValue(layers[j]['nominal-density'], 'float'));
      if(layers[j].hasOwnProperty('custom') && layers[j].custom === 'true') {
        layerProducts.push({name: '*' + layers[j]['name'], thickness: insulationLayers[insulationLayers.length - j - 1].selectedThickness});
      } else {
        layerProducts.push({name: layers[j]['Product-name'], thickness: insulationLayers[insulationLayers.length - j - 1].selectedThickness});
      }
    }

    uninsulatedHeatLossResults = thermalMath.heatLossIterative('pipe', getValue(material.Emissivity, 'float'),
      getValue(s.temperature, 'float'), getValue(s.environmentTemperature, 'float'),  [ getValue(material['Thermal-conductivity'], 'float') ],
      getValue(s.environmentAirVelocity, 'float'), [0], [getValue(s.outerDiameter, 'mmToMeters') - getValue(s.thickness, 'mmToMeters') * 2],
      [getValue(s.outerDiameter, 'mmToMeters')], true, {...target, unisulated: true});

    if(noInsulation) {
      heatLossResults = uninsulatedHeatLossResults;
    } else {
      heatLossResults = thermalMath.heatLossIterative('pipe', getValue(emissivity, 'float'),
      getValue(s.temperature, 'float'), getValue(s.environmentTemperature, 'float'),  lambdas,
          getValue(s.environmentAirVelocity, 'float'), [0], innerDiameters, outerDiameters, false, target);
    }

     retO.nominalWeight = thermalMath.calculateInsulationWeight('roundtank', innerDiameters, outerDiameters, 1, 0, 0, 0, nominalDensity);
  } else {
    thicknesses = [ [getValue(s.thickness, 'mmToMeters')] ];
    for(let j = 0; j < insulationLayers.length; j++) {
      layers.push(getItemByNid(insulationLayers[insulationLayers.length - j - 1].selectedItem, products));
      layers[j].thickness = insulationLayers[insulationLayers.length - j - 1].selectedThickness;
      lambdas.push([getValue(layers[j].a, 'float'), getValue(layers[j].b, 'float'), getValue(layers[j].c, 'float'), getValue(layers[j].d, 'float')]);
      thicknesses.push(getValue(layers[j].thickness, 'mmToMeters'));

      maxTemperatures.push({mst: getValue(layers[j].MST, 'int'), facing: getValue(layers[j]['Facing-MST'], 'int'), net: getValue(layers[j]['Net-MST'], 'int')});

      nominalDensity.push(getValue(layers[j]['nominal-density'], 'float'));
      if(layers[j].hasOwnProperty('custom') && layers[j].custom === 'true') {
        layerProducts.push({name: '*' + layers[j]['name'], thickness: insulationLayers[insulationLayers.length - j - 1].selectedThickness});
      } else {
        layerProducts.push({name: layers[j]['Product-name'], thickness: insulationLayers[insulationLayers.length - j - 1].selectedThickness});
      }
    }

    uninsulatedHeatLossResults = thermalMath.heatLossIterative('plane', getValue(material.Emissivity, 'float'),
        getValue(s.temperature, 'float'), getValue(s.environmentTemperature, 'float'),  [ getValue(material['Thermal-conductivity'], 'float') ],
        getValue(s.environmentAirVelocity, 'float'), [getValue(s.thickness, 'mmToMeters')], [0], [0], true, {...target, uninsulated: true});


    if(noInsulation) {
      heatLossResults = uninsulatedHeatLossResults;
    } else {
      heatLossResults = thermalMath.heatLossIterative('plane', getValue(emissivity, 'float'),
          getValue(s.temperature, 'float'), getValue(s.environmentTemperature, 'float'),  lambdas,
          getValue(s.environmentAirVelocity, 'float'), thicknesses, [0], [0], false, target);
    }

    retO.nominalWeight = thermalMath.calculateInsulationWeight('plane', 0, 0, 0, thicknesses, 1, 1, nominalDensity);
  }

  retO.heatloss = heatLossResults[2];
  retO.alphae = heatLossResults[1];
  retO.surfaceTemperature = heatLossResults[3][ heatLossResults[3].length - 1 ];
  retO.uninsulatedHeatLoss = uninsulatedHeatLossResults[2];
  retO.uninsulatedSurfaceTemperature = uninsulatedHeatLossResults[3][0];
  retO.dewPoint = thermalMath.dewPoint(getValue(s.environmentTemperature, 'float'), getValue(s.environmentHumidity, 'float'));
  retO.alphaR = heatLossResults[4][0];
  retO.alphaK = heatLossResults[4][1];
  retO.addition = heatLossResults[4][3];
  retO.joint = heatLossResults[4][4];

  retO.layers = [];
//          console.log('heatLossResults: ',heatLossResults)
  for(let j = 0; j < layers.length; j++) {
    retO.layers.push( { 'surfaceTemperature': heatLossResults[3][j + 1], 'thermalConductivity': heatLossResults[0][j] } );
    retO.layers[j].warnings = [];
    retO.layers[j].product = layerProducts[j];

    if(maxTemperatures[j].mst <= heatLossResults[3][j]) {
      retO.layers[j].warnings.push(ui['INSULATION-MATERIAL_MST_ALERT']);
    }
    if(maxTemperatures[j].facing <= heatLossResults[3][j + 1] && maxTemperatures[j].facing !== NaN) {
      retO.layers[j].warnings.push(ui['INSULATION-FACING_MST_ALERT']);
    }
    if(maxTemperatures[j].net <= heatLossResults[3][j + 1] && maxTemperatures[j].net !== NaN) {
      retO.layers[j].warnings.push(ui['INSULATION-NET_MST_ALERT']);
    }
  }

  if(supports.supportOfCladding) {
    retO.heatloss = retO.heatloss + ( retO.heatloss * supports.influenceOnHeatloss ) / 100;
  }

  if(claddingValue == -1) {
    retO.cladding = ui['GENERAL-OTHER_CLADDING'];
  } else if(claddingValue == -2) {
    retO.cladding = ui['GENERAL-NO_CLADDING'];
  } else if(cladding && cladding.hasOwnProperty('custom') && cladding.custom) {
    retO.cladding = cladding.name;
  } else if(!noInsulation) {
    retO.cladding = cladding; // (cladding[language]!==false)?cladding[language]:cladding['English'];
  } else {
    retO.cladding = '';
  }

  if(calcPipe) {
    const outerDiameterIndex = noInsulation ? 0 : outerDiameters.length - 1;
    retO.heatlossArea = thermalMath.heatlossConvertLengthToArea(retO.heatloss, outerDiameters[outerDiameterIndex], 0, 0);
    retO.uninsulatedHeatLossArea = thermalMath.heatlossConvertLengthToArea(retO.uninsulatedHeatLoss, outerDiameters[0], 0, 0);
    retO.coEmissionReduction = getValue( (thermalMath.emissionCO2('pipe', getValue(energySource['CO2-emission-per-W'], 'float'), c.energyOperationTime, uninsulatedHeatLossResults[2], 0, 0, uninsHeight) - thermalMath.emissionCO2('pipe', getValue(energySource['CO2-emission-per-W'], 'float'), c.energyOperationTime, retO.heatloss, 0, 0, height) ), 'gToKg');
    retO.annualSavingsKwh = Math.abs( getValue( (thermalMath.annualCostKwh('pipe', uninsulatedHeatLossResults[2], c.energyOperationTime, 0, 0, uninsHeight) - thermalMath.annualCostKwh('pipe', retO.heatloss, c.energyOperationTime, 0, 0, height) ), 'wToKwh') );
    retO.annualSavings = Math.abs( getValue( (thermalMath.annualCost('pipe', uninsulatedHeatLossResults[2], c.energyPrice, c.energyOperationTime, 0, 0, uninsHeight) - thermalMath.annualCost('pipe', retO.heatloss, c.energyPrice, c.energyOperationTime, 0, 0, height) ), 'cToE') );
  } else {
    retO.heatlossArea = retO.heatloss;
    retO.uninsulatedHeatLossArea = retO.uninsulatedHeatLoss;
    retO.coEmissionReduction = Math.abs( getValue( (thermalMath.emissionCO2('plane', getValue(energySource['CO2-emission-per-W'], 'float'), c.energyOperationTime, uninsulatedHeatLossResults[2], uninsWidth, uninsHeight, 0) - thermalMath.emissionCO2('plane', getValue(energySource['CO2-emission-per-W'], 'float'), c.energyOperationTime, retO.heatloss, width, height, 0)), 'gToKg') );
    retO.annualSavingsKwh = Math.abs( getValue( (thermalMath.annualCostKwh('plane', uninsulatedHeatLossResults[2], c.energyOperationTime, uninsWidth, uninsHeight, 0) - thermalMath.annualCostKwh('plane', retO.heatloss, c.energyOperationTime, width, height, 0)), 'wToKwh') );
    retO.annualSavings = Math.abs( getValue( (thermalMath.annualCost('plane', uninsulatedHeatLossResults[2], c.energyPrice, c.energyOperationTime, uninsWidth, uninsHeight, 0) - thermalMath.annualCost('plane', retO.heatloss, c.energyPrice, c.energyOperationTime, width, height, 0)), 'cToE') );
  }

  if(country === 'Denmark' || country === 'Sweden' || (settings.data[0]['countries-using-classes'].indexOf(country) !== -1)) {
      // calculateUValues(targetType, heatLoss, mediumTemp, outsideTemp, pipeDiameter, rectDuctWidth, rectDuctHeight, klasse:Object)
    let uKlasse = thermalMath.calculateUValues('plane', retO.heatloss, s.temperature, s.environmentTemperature, 0, 0, 0, s.klasse, settings, (settings.data[0]['countries-using-classes'].indexOf(country) !== -1), country);
    retO.uKlasseUnit = 'W/m²K';
    retO.uKlasse = uKlasse[0];
    retO.uKlasseNorm = uKlasse[1];
  }

  retO.warnings = {surface: [], object: []};
  if( nominalDensity.findIndex(item => item < 80) !== -1 && target.direction === 'vert' && getValue(s.temperature, 'float') >= 100 ) {
    retO.layers[layers.length - 1].warnings.push(
      ui['WARNING_MATERIAL_DENSITY']
    );
  }
  if( !noInsulation && ( retO.dewPoint + getValue(settings['Dew-point-tolerance'], 'int') ) >= heatLossResults[3][layers.length] ) {
    retO.warnings.surface.push(ui['INSULATION-DEWPOINT_ALERT']);
  }
  if( noInsulation && ( retO.dewPoint + getValue(settings['Dew-point-tolerance'], 'int') ) >= heatLossResults[3][0]) {
    retO.warnings.surface.push(ui['INSULATION-DEWPOINT_ALERT']);
  }
  if(getValue(material['Maximum-service-temperature'], 'int') <= getValue(s.temperature, 'float')) {
    retO.warnings.object.push(ui['INSULATION-OBJECT_MATERIAL_MST_ALERT']);
  }
  if(cladding && getValue(cladding['MST'], 'int') <= heatLossResults[3][layers.length]) {
    retO.warnings.surface.push(ui['INSULATION-CLADDING_ALERT']);
  }

  retO.heatloss = retO.heatlossArea;
  retO.uninsulatedHeatLoss = retO.uninsulatedHeatLossArea;
  return retO;
}

function calculateInsulationThickness(arr) {
  let retVal = 0;
  for(let i = 0; i < arr.length; i++) {
    retVal += getValue(getValue(arr[i].selectedThickness, 'float'), 'mmToMeters');
  }
  // console.log(retVal);
  return retVal;
}

export function createMiddleware() {
  return store => next => action => {
    const { type, payload } = action;
    const {
      claddings,
      energy,
      environments,
      materials,
      mediums,
      products,
      project,
      app,
      translations,
      settings,
    } = store.getState();

    const ui = buildUIStringArray(app.language, translations.data);

    switch (type) {
      case CALCULATION_CALCULATE_RESULTS:
        const c = getCalculation(project);
        if(c.type === CALCULATION_TYPE_VERTICAL_TANK || c.type === CALCULATION_TYPE_HORIZONTAL_TANK || c.type === CALCULATION_TYPE_RECTANGULAR_TANK) {
          // calculate
          next(action);
          var t0 = performance.now();

          let o = {};
          o.sectionResults = [];

          for(let i = 0; i < c.sections.length; i++)  {
            let s = c.sections[i];

            let material = getItemByNid(s.material, materials);
            let content = getItemByNid(s.content, mediums);
            let energySource = getItemByNid(c.energyType, energy);
            let environment = getItemByNid(s.environmentType, environments);
            let cladding;
            let height, width, uninsWidth, uninsHeight;

            if(s.type === CALCULATION_TYPE_VERTICAL_TANK) {
              let sideInsThickness = 0;
              s.sideInsulationLayers.forEach(ins => {
                sideInsThickness += getValue( parseInt(ins.selectedThickness), 'mmToMeters');
              });

              let topAndBotInsThickness = 0;
              s.topInsulationLayers.forEach(ins => {
                topAndBotInsThickness += getValue( parseInt(ins.selectedThickness), 'mmToMeters');
              });
              s.bottomInsulationLayers.forEach(ins => {
                topAndBotInsThickness += getValue( parseInt(ins.selectedThickness), 'mmToMeters');
              });

              const topDiamWithSideIns = getValue(s.outerDiameter, 'mmToMeters') + 2 * sideInsThickness;

              let targetDef = {
                type: 'plane',
                actualType: c.type + ', top',
                direction: 'hor',
                position: 'top',
                shape: 'round',
                height: getValue(s.height, 'mmToMeters') + topAndBotInsThickness,
                length: topDiamWithSideIns,
                width: topDiamWithSideIns,
                claddingSupport: s.sideValues.top.supportOfCladding,
                claddingSupportInfluence: getValue(s.sideValues.top.influenceOnHeatloss, 'float') * s.sideValues.top.spacersPerM,
                mechanicalFasteners: s.sideValues.top.mechanicalFastener,
                mechanicalInfluence: getValue(s.sideValues.top.mechanicalInfluence, 'float') * s.sideValues.top.mechanicalPerM,
                solarRadiation: c.calculateSolarRadiation,
                solarRadiationValue: s.environmentSolarRadiation * getValue(s.sideValues.top.emissivity, 'float'),
              };

              width =  Math.PI * Math.pow( (topDiamWithSideIns) / 2, 2);
              height = 1;
              uninsWidth = Math.PI * Math.pow( (getValue(s.outerDiameter, 'mmToMeters')) / 2, 2);
              uninsHeight = 1;
              cladding = getItemByNid(s.topCladding, claddings);
              o.sectionResults.push( {topLayers: makeFaceCalculation(c, ui, s, s.topCladding, s.topNoInsulation, s.topInsulationLayers, s.sideValues.top, s.topEmissivity, width, height, material, content, energySource, environment, cladding, products, settings, app.language, app.country, false, targetDef, uninsWidth, uninsHeight)} );

              targetDef = {
                type: 'plane',
                actualType: c.type + ', ' + s.tankBase,
                direction: 'hor',
                position: 'bottom',
                shape: 'round',
                length: topDiamWithSideIns,
                width: topDiamWithSideIns,
                claddingSupport: s.sideValues.bottom.supportOfCladding,
                claddingSupportInfluence: getValue(s.sideValues.bottom.influenceOnHeatloss, 'float') * s.sideValues.bottom.spacersPerM,
                mechanicalFasteners: s.sideValues.bottom.mechanicalFastener,
                mechanicalInfluence: getValue(s.sideValues.bottom.mechanicalInfluence, 'float') * s.sideValues.bottom.mechanicalPerM,
                solarRadiation: c.calculateSolarRadiation,
                solarRadiationValue: s.environmentSolarRadiation * getValue(s.sideValues.bottom.emissivity, 'float'),
              };

              cladding = getItemByNid(s.bottomCladding, claddings);
              o.sectionResults[i].bottomLayers = makeFaceCalculation(c, ui, s, s.bottomCladding, s.bottomNoInsulation, s.bottomInsulationLayers, s.sideValues.bottom, s.bottomEmissivity, width, height, material, content, energySource, environment, cladding, products, settings, app.language, app.country, false, targetDef, uninsWidth, uninsHeight);

              if(s.tankBase === 'concrete') {
                const concreteTotalHeatloss = thermalMath.calculateConcreteHeatloss({
                  diam: getValue(s.outerDiameter, 'mmToMeters'),
                  cThick: getValue(s.concreteThickness, 'mmToMeters'),
                  ambientTemp: parseFloat(s.environmentTemperature),
                  mediumTemp: s.temperature,
                  type: 'round'
                });
                const bottomArea = Math.PI * Math.pow( (getValue(s.outerDiameter, 'mmToMeters') / 2 ), 2 );
                o.sectionResults[i].bottomLayers.heatloss = concreteTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.heatlossArea = concreteTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.uninsulatedHeatLoss = concreteTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.uninsulatedHeatLossArea = concreteTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.alphae = 0;
                o.sectionResults[i].bottomLayers.alphaR = 0;
                o.sectionResults[i].bottomLayers.alphaK = 0;
              } else if(s.tankBase === 'ground' ) {
                const soilTotalHeatloss = thermalMath.calculateSoilHeatloss({
                  diam: getValue(s.outerDiameter, 'mmToMeters'),
                  ambientTemp: parseFloat(s.environmentTemperature),
                  mediumTemp: s.temperature,
                  type: 'round'
                });
                const bottomArea = Math.PI * Math.pow( (getValue(s.outerDiameter, 'mmToMeters') / 2 ), 2 );
                // console.log('----------->',{soilTotalHeatloss,bottomArea})
                o.sectionResults[i].bottomLayers.heatloss = soilTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.heatlossArea = soilTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.uninsulatedHeatLoss = soilTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.uninsulatedHeatLossArea = soilTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.alphae = 0;
                o.sectionResults[i].bottomLayers.alphaR = 0;
                o.sectionResults[i].bottomLayers.alphaK = 0;
              }

              // width = 2 * Math.PI * (getValue(s.outerDiameter,'mmToMeters') / 2 );
              width = Math.PI * topDiamWithSideIns;
              height = getValue(s.height, 'mmToMeters') + topAndBotInsThickness;
              uninsWidth = Math.PI * getValue(s.outerDiameter, 'mmToMeters');
              uninsHeight = getValue(s.height, 'mmToMeters');

              cladding = getItemByNid(s.sideCladding, claddings);
              if( s.outerDiameter > getValue(settings['Diameter-pipe'], 'float') ) {
                targetDef = {
                  type: 'plane',
                  actualType: c.type + ', side',
                  direction: 'vert',
                  shape: 'square',
                  length: topDiamWithSideIns,
                  width: width,
                  height: height,
                  claddingSupport: s.sideValues.side.supportOfCladding,
                  claddingSupportInfluence: getValue(s.sideValues.side.influenceOnHeatloss, 'float') * s.sideValues.side.spacersPerM,
                  mechanicalFasteners: s.sideValues.side.mechanicalFastener,
                  mechanicalInfluence: getValue(s.sideValues.side.mechanicalInfluence, 'float') * s.sideValues.side.mechanicalPerM,
                  solarRadiation: c.calculateSolarRadiation,
                  solarRadiationValue: s.environmentSolarRadiation * getValue(s.sideValues.side.emissivity, 'float'),

                };
                o.sectionResults[i].sideLayers = makeFaceCalculation(c, ui, s, s.sideCladding, s.sideNoInsulation, s.sideInsulationLayers, s.sideValues.side, s.sideEmissivity, width, height, material, content, energySource, environment, cladding, products, settings, app.language, app.country, false, targetDef, uninsWidth, uninsHeight);
              } else {
                targetDef = {
                  type: 'pipe',
                  actualType: c.type + ', side as pipe',
                  direction: 'vert',
                  length: height,
                  diameter: topDiamWithSideIns,
                  claddingSupport: s.sideValues.side.supportOfCladding,
                  claddingSupportInfluence: getValue(s.sideValues.side.influenceOnHeatloss, 'float') * s.sideValues.side.spacersPerM,
                  mechanicalFasteners: s.sideValues.side.mechanicalFastener,
                  mechanicalInfluence: getValue(s.sideValues.side.mechanicalInfluence, 'float') * s.sideValues.side.mechanicalPerM,
                  solarRadiation: c.calculateSolarRadiation,
                  solarRadiationValue: s.environmentSolarRadiation * getValue(s.sideValues.side.emissivity, 'float'),

                };
                o.sectionResults[i].sideLayers = makeFaceCalculation(c, ui, s, s.sideCladding, s.sideNoInsulation, s.sideInsulationLayers, s.sideValues.side, s.sideEmissivity, width, height, material, content, energySource, environment, cladding, products, settings, app.language, app.country, true, targetDef, uninsWidth, uninsHeight);
              }
            } else if(s.type === CALCULATION_TYPE_HORIZONTAL_TANK) {
              let sideInsThickness = 0;
              s.sideInsulationLayers.forEach(ins => {
                sideInsThickness += getValue( parseInt(ins.selectedThickness), 'mmToMeters');
              });

              let topAndBotInsThickness = 0;
              s.topInsulationLayers.forEach(ins => {
                topAndBotInsThickness += getValue( parseInt(ins.selectedThickness), 'mmToMeters');
              });

              topAndBotInsThickness *= 2;

              const topDiamWithSideIns = getValue(s.outerDiameter, 'mmToMeters') + 2 * sideInsThickness;

              cladding = getItemByNid(s.cladding, claddings);

              let targetDef = {
                type: 'plane',
                actualType: c.type + ', ends',
                direction: 'vert',
                shape: 'round',
                length: topDiamWithSideIns,
                width: topDiamWithSideIns,
                diameter: topDiamWithSideIns,
                claddingSupport: s.supportOfCladding,
                claddingSupportInfluence: getValue(s.influenceOnHeatloss, 'float') * s.spacersPerM,
                mechanicalFasteners: s.mechanicalFastener,
                mechanicalInfluence: getValue(s.mechanicalInfluence, 'float') * s.mechanicalPerM,
                solarRadiation: c.calculateSolarRadiation,
                solarRadiationValue: s.environmentSolarRadiation * getValue(s.emissivity, 'float'),

              };

              width =  Math.PI * Math.pow( topDiamWithSideIns / 2, 2);
              height = 1;
              uninsWidth =  Math.PI * Math.pow( getValue(s.outerDiameter, 'mmToMeters') / 2, 2);
              uninsHeight = 1;

              o.sectionResults.push( {topLayers: makeFaceCalculation(c, ui, s, s.topCladding, s.noInsulation, s.insulationLayers, {supportOfCladding: s.supportOfCladding, influenceOnHeatloss: s.influenceOnHeatloss}, s.emissivity, width, height, material, content, energySource, environment, cladding, products, settings, app.language, app.country, false, targetDef, uninsWidth, uninsHeight)} );
              o.sectionResults[i].bottomLayers = makeFaceCalculation(c, ui, s, s.topCladding, s.noInsulation, s.insulationLayers, {supportOfCladding: s.supportOfCladding, influenceOnHeatloss: s.influenceOnHeatloss}, s.emissivity, width, height, material, content, energySource, environment, cladding, products, settings, app.language, app.country, false, targetDef, uninsWidth, uninsHeight);

              width = 2 * Math.PI * ( (getValue(s.outerDiameter, 'mmToMeters') / 2 ) + sideInsThickness);
              height = getValue(s.length, 'mmToMeters') + topAndBotInsThickness;
              uninsWidth = 2 * Math.PI * (getValue(s.outerDiameter, 'mmToMeters') / 2 );
              uninsHeight = getValue(s.length, 'mmToMeters');

              if( s.outerDiameter > getValue(settings['Diameter-pipe'], 'float') ) {
                targetDef = {
                  type: 'plane',
                  actualType: c.type + ', side',
                  direction: 'hor',
                  shape: 'square',
                  length: getValue(s.length, 'mmToMeters') + topAndBotInsThickness,
                  width: 2 * Math.PI * ( (getValue(s.outerDiameter, 'mmToMeters') / 2 ) + sideInsThickness),
                  claddingSupport: s.supportOfCladding,
                  claddingSupportInfluence: getValue(s.influenceOnHeatloss, 'float') * s.spacersPerM,
                  mechanicalFasteners: s.mechanicalFastener,
                  mechanicalInfluence: getValue(s.mechanicalInfluence, 'float') * s.mechanicalPerM,
                  solarRadiation: c.calculateSolarRadiation,
                  solarRadiationValue: s.environmentSolarRadiation * getValue(s.emissivity, 'float'),

                };
                o.sectionResults[i].sideLayers = makeFaceCalculation(c, ui, s, s.topCladding, s.noInsulation, s.insulationLayers, {supportOfCladding: s.supportOfCladding, influenceOnHeatloss: s.influenceOnHeatloss}, s.emissivity, width, height, material, content, energySource, environment, cladding, products, settings, app.language, app.country, false, targetDef, uninsWidth, uninsHeight);
              } else {
                targetDef = {
                  type: 'pipe',
                  actualType: c.type + ', side as pipe',
                  direction: 'hor',
                  length: height,
                  diameter: topDiamWithSideIns,
                  claddingSupport: s.supportOfCladding,
                  claddingSupportInfluence: getValue(s.influenceOnHeatloss, 'float') * s.spacersPerM,
                  mechanicalFasteners: s.mechanicalFastener,
                  mechanicalInfluence: getValue(s.mechanicalInfluence, 'float') * s.mechanicalPerM,
                  solarRadiation: c.calculateSolarRadiation,
                  solarRadiationValue: s.environmentSolarRadiation * getValue(s.emissivity, 'float'),

                };
                o.sectionResults[i].sideLayers = makeFaceCalculation(c, ui, s, s.topCladding, s.noInsulation, s.insulationLayers, {supportOfCladding: s.supportOfCladding, influenceOnHeatloss: s.influenceOnHeatloss}, s.emissivity, width, height, material, content, energySource, environment, cladding, products, settings, app.language, app.country, true, targetDef, uninsWidth, uninsHeight);
              }
            } else if(s.type === CALCULATION_TYPE_RECTANGULAR_TANK) {
              let sideInsThickness = 0;
              s.sideInsulationLayers.forEach(ins => {
                sideInsThickness += getValue( parseInt(ins.selectedThickness), 'mmToMeters');
              });

              let topAndBotInsThickness = 0;
              s.topInsulationLayers.forEach(ins => {
                topAndBotInsThickness += getValue( parseInt(ins.selectedThickness), 'mmToMeters');
              });
              s.bottomInsulationLayers.forEach(ins => {
                topAndBotInsThickness += getValue( parseInt(ins.selectedThickness), 'mmToMeters');
              });

              let targetDef = {
                type: 'plane',
                actualType: c.type + ', top',
                direction: 'hor',
                shape: 'square',
                position: 'top',
                length: getValue(s.length, 'mmToMeters') + 2 * sideInsThickness,
                width: getValue(s.width, 'mmToMeters') + 2 * sideInsThickness,
                claddingSupport: s.sideValues.top.supportOfCladding,
                claddingSupportInfluence: getValue(s.sideValues.top.influenceOnHeatloss, 'float') * s.sideValues.top.spacersPerM,
                mechanicalFasteners: s.sideValues.top.mechanicalFastener,
                mechanicalInfluence: getValue(s.sideValues.top.mechanicalInfluence, 'float') * s.sideValues.top.mechanicalPerM,
                solarRadiation: c.calculateSolarRadiation,
                solarRadiationValue: s.environmentSolarRadiation * getValue(s.sideValues.top.emissivity, 'float'),

              };

              width =  getValue(s.length, 'mmToMeters') + 2 * sideInsThickness;
              height = getValue(s.length, 'mmToMeters') + 2 * sideInsThickness;
              uninsWidth =  getValue(s.width, 'mmToMeters');
              uninsHeight = getValue(s.length, 'mmToMeters');

              cladding = getItemByNid(s.topCladding, claddings);
              o.sectionResults.push( {topLayers: makeFaceCalculation(c, ui, s, s.topCladding, s.topNoInsulation, s.topInsulationLayers, s.sideValues.top, s.topEmissivity, width, height, material, content, energySource, environment, cladding, products, settings, app.language, app.country, false, targetDef, uninsWidth, uninsHeight)} );

              targetDef = {
                ...targetDef,
                actualType: c.type + ', bottom on legs',
                position: 'bottom',
                claddingSupport: s.sideValues.bottom.supportOfCladding,
                claddingSupportInfluence: getValue(s.sideValues.bottom.influenceOnHeatloss, 'float') * s.sideValues.bottom.spacersPerM,
                mechanicalFasteners: s.sideValues.bottom.mechanicalFastener,
                mechanicalInfluence: getValue(s.sideValues.bottom.mechanicalInfluence, 'float') * s.sideValues.bottom.mechanicalPerM,
                solarRadiation: c.calculateSolarRadiation,
                solarRadiationValue: s.environmentSolarRadiation * getValue(s.sideValues.bottom.emissivity, 'float'),

              };
              cladding = getItemByNid(s.bottomCladding, claddings);

              o.sectionResults[i].bottomLayers = makeFaceCalculation(c, ui, s, s.bottomCladding, s.bottomNoInsulation, s.bottomInsulationLayers, s.sideValues.bottom, s.bottomEmissivity, width, height, material, content, energySource, environment, cladding, products, settings, app.language, app.country, false, targetDef, uninsWidth, uninsHeight);

              if(s.tankBase === 'concrete') {
                const concreteTotalHeatloss = thermalMath.calculateConcreteHeatloss({
                  width: getValue(s.width, 'mmToMeters'),
                  length: getValue(s.length, 'mmToMeters'),
                  cThick: getValue(s.concreteThickness, 'mmToMeters'),
                  ambientTemp: parseFloat(s.environmentTemperature),
                  mediumTemp: s.temperature,
                  type: 'square'
                });
                const bottomArea = getValue(s.width, 'mmToMeters') * getValue(s.length, 'mmToMeters');
                o.sectionResults[i].bottomLayers.heatloss = concreteTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.heatlossArea = concreteTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.uninsulatedHeatLoss = concreteTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.uninsulatedHeatLossArea = concreteTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.alphae = 0;
                o.sectionResults[i].bottomLayers.alphaR = 0;
                o.sectionResults[i].bottomLayers.alphaK = 0;
              } else if(s.tankBase === 'ground' ) {
                const soilTotalHeatloss = thermalMath.calculateSoilHeatloss({
                  width: getValue(s.width, 'mmToMeters'),
                  length: getValue(s.length, 'mmToMeters'),
                  ambientTemp: parseFloat(s.environmentTemperature),
                  mediumTemp: s.temperature,
                  type: 'square'
                });
                const bottomArea = getValue(s.width, 'mmToMeters') * getValue(s.length, 'mmToMeters');
                o.sectionResults[i].bottomLayers.heatloss = soilTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.heatlossArea = soilTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.uninsulatedHeatLoss = soilTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.uninsulatedHeatLossArea = soilTotalHeatloss / bottomArea;
                o.sectionResults[i].bottomLayers.alphae = 0;
                o.sectionResults[i].bottomLayers.alphaR = 0;
                o.sectionResults[i].bottomLayers.alphaK = 0;
              }


              width = 2 * (getValue(s.width, 'mmToMeters') + 2 * sideInsThickness) + 2 * (getValue(s.length, 'mmToMeters') + 2 * sideInsThickness);
              height = getValue(s.height, 'mmToMeters') + topAndBotInsThickness;
              uninsWidth = 2 * getValue(s.width, 'mmToMeters') + 2 * getValue(s.length, 'mmToMeters');
              uninsHeight = getValue(s.height, 'mmToMeters');

              targetDef = {
                type: 'plane',
                actualType: c.type + ', side',
                direction: 'vert',
                shape: 'square',
                height: getValue(s.height, 'mmToMeters') + topAndBotInsThickness,
                width: getValue(s.length, 'mmToMeters') + 2 * sideInsThickness,
                claddingSupport: s.sideValues.side.supportOfCladding,
                claddingSupportInfluence: getValue(s.sideValues.side.influenceOnHeatloss, 'float') * s.sideValues.side.spacersPerM,
                mechanicalFasteners: s.sideValues.side.mechanicalFastener,
                mechanicalInfluence: getValue(s.sideValues.side.mechanicalInfluence, 'float') * s.sideValues.side.mechanicalPerM,
                solarRadiation: c.calculateSolarRadiation,
                solarRadiationValue: s.environmentSolarRadiation * getValue(s.sideValues.side.emissivity, 'float'),

              };

              cladding = getItemByNid(s.sideCladding, claddings);
              o.sectionResults[i].sideLayers = makeFaceCalculation(c, ui, s, s.sideCladding, s.sideNoInsulation, s.sideInsulationLayers, s.sideValues.side, s.sideEmissivity, width, height, material, content, energySource, environment, cladding, products, settings, app.language, app.country, false, targetDef, uninsWidth, uninsHeight);
            }

            o.sectionResults[i].material = (material.hasOwnProperty('custom') && material.custom) ? material.name : material; // (material[app.language]!==false)?material[app.language]:material['English'];
            o.sectionResults[i].energySource = (energySource.hasOwnProperty('custom') && energySource.custom) ? energySource.name : energySource; // (energySource[app.language]!==false)?energySource[app.language]:energySource['English'];
            o.sectionResults[i].content = (content.hasOwnProperty('custom') && content.custom) ? content.name : content; // (content[app.language]!==false)?content[app.language]:content['English'];
          }

          let topArea, bottomArea, sideArea, vesselVolume, phi, areas;
          let topAreaUn, bottomAreaUn, sideAreaUn;
          const section = getSection(c);

          let topThickness = calculateInsulationThickness(c.sections[0].topInsulationLayers);
          let sideThickness = calculateInsulationThickness(c.sections[0].sideInsulationLayers);
          let bottomThickness = calculateInsulationThickness(c.sections[0].bottomInsulationLayers);

          if(c.type === CALCULATION_TYPE_VERTICAL_TANK) {
            topArea = Math.PI * Math.pow( ( getValue(section.outerDiameter, 'mmToMeters') / 2 + sideThickness), 2);
            bottomArea = topArea;
            sideArea = Math.PI * (getValue(section.outerDiameter, 'mmToMeters') + 2 * sideThickness) * (getValue(section.height, 'mmToMeters') + topThickness + bottomThickness);
            topAreaUn = Math.PI * Math.pow( ( getValue(section.outerDiameter, 'mmToMeters') / 2), 2);
            bottomAreaUn = topAreaUn;
            sideAreaUn = Math.PI * (getValue(section.outerDiameter, 'mmToMeters')) * (getValue(section.height, 'mmToMeters'));
            vesselVolume = topArea * getValue(section.height, 'mmToMeters');
            phi = [o.sectionResults[0].topLayers.heatloss, o.sectionResults[0].sideLayers.heatloss, o.sectionResults[0].bottomLayers.heatloss];

            const s = c.sections[0];
            if(s.topNoInsulation) topArea = topAreaUn;
            if(s.bottomNoInsulation) bottomArea = bottomAreaUn;
            if(s.sideNoInsulation) sideArea = sideAreaUn;

            areas = [topArea, sideArea, bottomArea];
          } else if(c.type === CALCULATION_TYPE_HORIZONTAL_TANK) {
            topThickness = calculateInsulationThickness(c.sections[0].insulationLayers);
            sideThickness = calculateInsulationThickness(c.sections[0].insulationLayers);
            bottomThickness = calculateInsulationThickness(c.sections[0].insulationLayers);

            topArea = Math.PI * Math.pow( ( getValue(section.outerDiameter, 'mmToMeters') / 2 + sideThickness), 2);
            bottomArea = topArea;
            sideArea = Math.PI * (getValue(section.outerDiameter, 'mmToMeters') + 2 * sideThickness) * (getValue(section.length, 'mmToMeters') + topThickness + bottomThickness);
            topAreaUn = Math.PI * Math.pow( ( getValue(section.outerDiameter, 'mmToMeters') / 2), 2);
            bottomAreaUn = topAreaUn;
            sideAreaUn = Math.PI * (getValue(section.outerDiameter, 'mmToMeters')) * (getValue(section.length, 'mmToMeters'));
            vesselVolume = topArea * getValue(section.length, 'mmToMeters');
            phi = [o.sectionResults[0].topLayers.heatloss, o.sectionResults[0].sideLayers.heatloss, o.sectionResults[0].bottomLayers.heatloss];
            areas = [topArea, sideArea, bottomArea];

            const s = c.sections[0];
            if(s.noInsulation) {
              topArea = topAreaUn;
              bottomArea = bottomAreaUn;
              sideArea = sideAreaUn;
            }
          } else {
            topArea = (getValue(section.width, 'mmToMeters') + 2 * sideThickness) * (getValue(section.length, 'mmToMeters') + 2 * sideThickness);
            sideArea = 2 * (getValue(section.width, 'mmToMeters') + 2 * sideThickness) * (getValue(section.height, 'mmToMeters') + topThickness + bottomThickness) + 2 * (getValue(section.length, 'mmToMeters') + 2 * sideThickness) * (getValue(section.height, 'mmToMeters') + topThickness + bottomThickness);
            bottomArea = topArea;
            topAreaUn = (getValue(section.width, 'mmToMeters')) * (getValue(section.length, 'mmToMeters'));
            sideAreaUn = 2 * (getValue(section.width, 'mmToMeters')) * (getValue(section.height, 'mmToMeters')) + 2 * (getValue(section.length, 'mmToMeters')) * (getValue(section.height, 'mmToMeters'));
            bottomAreaUn = topAreaUn;
            vesselVolume = getValue(section.length, 'mmToMeters') * getValue(section.width, 'mmToMeters') * getValue(section.height, 'mmToMeters');

            const s = c.sections[0];
            if(s.topNoInsulation) topArea = topAreaUn;
            if(s.bottomNoInsulation) bottomArea = bottomAreaUn;
            if(s.sideNoInsulation) sideArea = sideAreaUn;

            phi = [o.sectionResults[0].topLayers.heatloss, o.sectionResults[0].sideLayers.heatloss, o.sectionResults[0].bottomLayers.heatloss];
            areas = [topArea, sideArea, bottomArea];
          }

          let content = getItemByNid(section.content, mediums);
          o.heatloss = o.sectionResults[0].topLayers.heatloss * topArea + o.sectionResults[0].sideLayers.heatloss * sideArea + o.sectionResults[0].bottomLayers.heatloss * bottomArea;
          o.uninsulatedHeatLoss = o.sectionResults[0].topLayers.uninsulatedHeatLoss * topAreaUn + o.sectionResults[0].sideLayers.uninsulatedHeatLoss * sideAreaUn + o.sectionResults[0].bottomLayers.uninsulatedHeatLoss * bottomAreaUn;
          o.heatLossPerSqrM = o.heatloss / (topArea + sideArea + bottomArea);
          o.unisulatedHeatLossPerSqrM = o.uninsulatedHeatLoss / (topAreaUn + sideAreaUn + bottomAreaUn);
          // o.totalNominalWeight = o.sectionResults[0].topLayers.nominalWeight + o.sectionResults[0].sideLayers.nominalWeight + o.sectionResults[0].bottomLayers.nominalWeight;
          o.dewPoint =  o.sectionResults[0].topLayers.dewPoint;
          o.annualSavingsKwh = o.sectionResults[0].topLayers.annualSavingsKwh + o.sectionResults[0].sideLayers.annualSavingsKwh + o.sectionResults[0].bottomLayers.annualSavingsKwh;
          o.annualSavings = o.sectionResults[0].topLayers.annualSavings + o.sectionResults[0].sideLayers.annualSavings + o.sectionResults[0].bottomLayers.annualSavings;
          o.coEmissionReduction = o.sectionResults[0].topLayers.coEmissionReduction + o.sectionResults[0].sideLayers.coEmissionReduction + o.sectionResults[0].bottomLayers.coEmissionReduction;

          let coolingTime = thermalMath.coolingTimeVessel(section.temperature, section.finalTemperature, section.environmentTemperature, phi, areas, vesselVolume, getValue(content['Heat-capasity'], 'float'), getValue(content['Density'], 'float' ) );
          o.coolingTime = (isNaN(coolingTime) ) ? '-' : getValue(coolingTime, 'secToH');

          // console.log('Tank results: ',o);

          var t1 = performance.now();
          // console.log("Call to doSomething took " + (t1 - t0) + " milliseconds.");

          store.dispatch(updateResults(o));
        } else {
          next(action);
        }

        break;

      default:
        next(action);
    }
  };
}
